/*==========================================================================
        onResizeHome
==========================================================================*/
portfolioAPP.onResizeHome = function () {
  var w = window,
  d = document,
  e = d.documentElement,
  g = d.getElementsByTagName('body')[0],
  x = w.innerWidth || e.clientWidth || g.clientWidth;

  var width = $(window).width();
  $(window).on('resize', function() {
    
    if ($(this).width() != width) {
      width = $(this).width();
    
    var t = w.innerWidth || e.clientWidth || g.clientWidth;
    if(t !== x) {

      screenHeight = $(window).height();

      mainController.destroy(true);

      window.mainController = new ScrollMagic.Controller({refreshInterval: 0})
        
      portfolioAPP.homeScrollMagic()

      if (portfolioAPP.onInitialise()!='isTouchDevice'){
        portfolioAPP.smoothScroll()
        portfolioAPP.homeScrollTo()
        scrollBar.setPosition(0, 0)
        if (portfolioAPP.onInitialise()=='isLargeScreen'){ 
          portfolioAPP.homeScrollMagicLaptop() 
        }
      }else{
        window.scrollTo(0, 0)
      } 

    }
    setTimeout(function() {
      window.location.reload();
    });
    arrayOffsets = [screenHeight, screenHeight * .1, screenHeight * .2, screenHeight * .3, screenHeight * .4, screenHeight * .5]
    }

  });

}
/*==========================================================================
        onResizeHome
==========================================================================*/




/*==========================================================================
        homeAvatarHover
==========================================================================*/
portfolioAPP.homeAvatarHover = function () {

  var timeout;
  $('#avatarContainer').mousemove(function (e) {
    if (timeout) clearTimeout(timeout);
    setTimeout(callParallax.bind(null, e), 0);
  });

  function callParallax(e) {
    parallaxIt(e, '.avatar1', -5);
    parallaxIt(e, '.avatar2', 5);
    parallaxIt(e, '.avatar4', 10);
    parallaxIt(e, '.avatar10', 5);
    parallaxIt(e, '.avatar11', -5);
    parallaxIt(e, '.avatar12', 10);
    parallaxIt(e, '.avatar13', -5);
  }

  function parallaxIt(e, target, resistance) {
    $this = $(target);
    TweenLite.to($this, 0.2, {
      x: '-' + 50 - ((e.clientX - (window.innerWidth / 2)) / resistance / 50) + '%',
      y: -((e.clientY - (window.innerHeight / 2)) / resistance / 25),
    });
  }

}
/*==========================================================================
        homeAvatarHover
==========================================================================*/






/*==========================================================================
        homeAboutTabs
==========================================================================*/
portfolioAPP.homeAboutTabs = function () {

  $('.tabsMenuCopyWrap').height($('.tabsMenuCopy.active').height())

  function showTab(el) {
    for (i = 0; i < 3; ++i) {
      if (tabsMenuItem[i].classList.contains("active")) tabsMenuItem[i].classList.remove("active")
    }
    document.getElementById(el).className += " active"
    var elCopy = document.getElementById(el + 'Copy')
    var tabs = document.querySelectorAll('.tabsMenuCopy')
    for (i = 0; i < tabs.length; ++i) {
      var tab = tabs[i];
      if (tab.id != elCopy.id) {
        tab.classList.remove("active")
      } else {
        tab.classList.add("active")
      };
    }
  }

  var tabsMenuItem = document.querySelectorAll('.tabsMenu')

  for (i = 0; i < tabsMenuItem.length; ++i) {
    (function () {
      tabsMenuItem[i].addEventListener('click', function () {
        showTab(this.id)
      });
    }()); // immediate invocation
  }
}
/*==========================================================================
        homeAboutTabs
==========================================================================*/




/*==========================================================================
        homeScrollTo
==========================================================================*/
portfolioAPP.homeScrollTo = function () {
  // -----------------  scrollTo
  $(document).on("click", "#nav a", function (e) {
    offsetTop = document.getElementById(e.currentTarget.id.slice(1)).getBoundingClientRect().top;
    scrollBar.scrollTo(0, scrollBar.offset.y + offsetTop, 1000, {
      //callback: () => console.log('done!'),
      //easing: easing.easeOutBack,
    });
  })
}
/*==========================================================================
        homeScrollTo
==========================================================================*/




/*==========================================================================
        homeScrollMagic
==========================================================================*/
portfolioAPP.homeScrollMagic = function () {

  let preloaderAnimation = loader.imagesLoader()

  if (preloaderAnimation.to($(".preloaderWrapHome .progress span"), 1, { width: 100, ease: Linear.easeNone})) {

    // -----------------  animationHeader
    var animationHeaderTitle = new TimelineMax()
    animationHeaderTitle
      .fromTo($(".greetingName .headerIntro"), .5, { css: {opacity: 1} }, { css: {opacity: 0} })
      .fromTo($(".greetingName #headerTitlePepeLopez"), 1, {y: 0}, {y: arrayOffsets[3]}, "-=.5")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: "#header",
        triggerHook: 0,
        offset: 15,
        duration: "100%"
      })
      .setTween(animationHeaderTitle)
      .reverse(true)
      //.addIndicators({ name: "animationHeader" })
      .addTo(mainController)
    )

      // animationHeader
      var animationHeader = new TimelineMax()
      animationHeader
        .add([TweenMax.staggerTo('.avatarLayerFade', 0.35, {css: {top:-arrayOffsets[1]/3, opacity: 0}, ease:Power0.easeInOut }, 0.05) ]).pause();


      var fired = false;
      if (portfolioAPP.onInitialise()!='isTouchDevice'){

        scrollBar.addListener(function (status) {
          y_scroll_pos = status.offset.y;
          if (y_scroll_pos > 0) {  
            animationHeader.play();
        }
        if (y_scroll_pos == 0) {  
            animationHeader.reverse();
        }
        });
      }else{
        $(window).scroll(function() {
          console.log('HERE');
          var y_scroll_pos = $(this).scrollTop();
          if (y_scroll_pos > 0 && fired === false) {  
              animationHeader.play();
              fired = true;
          }
          if (y_scroll_pos == 0 && fired === true) {  
              animationHeader.reverse();
              fired = false;
          }
        })
      }




    // -----------------  animationAbout
    var animationAbout = new TimelineMax()
    animationAbout
      .fromTo($(".aboutClayMockup"), 1, { y: arrayOffsets[2] }, {y: 0} )
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: "#about",
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(animationAbout)
      //.addIndicators({ name: "animationAbout" })
      .addTo(mainController)
    )


    // -----------------  animationSlideIntro
    var animationSlideIntro = new TimelineMax()
    animationSlideIntro
      .to($("#slideIntro .slideIntroLayerDawn"), 1, {y: -arrayOffsets[0]}, "-=.35")
      .fromTo($("#slideIntro h1"), 1, {y: arrayOffsets[3]}, {y: -arrayOffsets[3]}, "-=1")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: "#slideIntro",
        triggerHook: 0.5,
        duration: "100%"
      })
      .setTween(animationSlideIntro)
      //.addIndicators({ name: "animationSlideIntro" })
      .addTo(mainController)
    )


    // -----------------  animationExperience
    // Set initial state for fade-in elements
    TweenMax.set($("#experience h1, #experience .experience-table tbody tr"), {opacity: 0, y: 30})
    
    var animationExperience = new TimelineMax()
    animationExperience
      .fromTo($("#experience .experience-container"), 1, {y: arrayOffsets[1]}, {y: -arrayOffsets[1]}, "-=1")
      .to($("#experience h1"), 0.6, {opacity: 1, y: 0, ease: Power2.easeOut}, "-=0.8")
      .staggerTo($("#experience .experience-table tbody tr"), 0.8, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.15, "-=0.5")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: "#experience",
        triggerHook: 0.75,
        duration: "100%"
      })
      .setTween(animationExperience)
      //.addIndicators({ name: "animationExperience" })
      .addTo(mainController)
    )


    // -----------------  animationProjectsStats
    // Set initial state for fade-in elements
    TweenMax.set($("#projectsStats .projectsStatsIntro, #projectsStats .projectsStatsList li, #projectsStats .projectsStatsCTA"), {opacity: 0, y: 30})
    
    var animationProjectsStats = new TimelineMax()
    animationProjectsStats
      .fromTo($("#projectsStats .projectsStatsContent"), 1, {y: arrayOffsets[1]}, {y: -arrayOffsets[1]}, "-=1")
      .to($("#projectsStats .projectsStatsIntro"), 0.6, {opacity: 1, y: 0, ease: Power2.easeOut}, "-=0.8")
      .staggerTo($("#projectsStats .projectsStatsList li"), 0.8, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.15, "-=0.5")
      .to($("#projectsStats .projectsStatsCTA"), 0.6, {opacity: 1, y: 0, ease: Power2.easeOut}, "-=0.3")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: "#projectsStats",
        triggerHook: 0.75,
        duration: "100%"
      })
      .setTween(animationProjectsStats)
      //.addIndicators({ name: "animationProjectsStats" })
      .addTo(mainController)
    )


    // -----------------  meetr
    var animationBGmeetr = new TimelineMax()
    animationBGmeetr
      .fromTo($(".meetrBg"), 1, {y: arrayOffsets[4]}, {y: -arrayOffsets[4]})
      .fromTo($(".meetrBg img"), 1, {rotation: 0}, {rotation: 360}, '-=1')
      .fromTo($("#meetr .bgTitleSection_l"), 1, {y: arrayOffsets[1] / 5}, {y: -arrayOffsets[1] / 5}, '-=1')
      .fromTo($("#meetr .startupsimg01"), 1, {y: arrayOffsets[2]}, {y: 0}, '-=1')
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#meetr',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(animationBGmeetr)
      //.addIndicators({ name: "#meetr" })
      .addTo(mainController)
    )


    // -----------------  publishcheck
    var animationBGpublishcheck = new TimelineMax()
    animationBGpublishcheck
      .fromTo($(".publishcheckBg"), 1, {y: arrayOffsets[4]}, {y: -arrayOffsets[4]})
      .fromTo($(".publishcheckBg img"), 1, {rotation: 0}, {rotation: 360}, '-=1')
      .fromTo($("#publishcheck .bgTitleSection_l"), 1, {y: arrayOffsets[1] / 5}, {y: -arrayOffsets[1] / 5}, '-=1')
      .fromTo($("#publishcheck .startupsimg01"), 1, {y: arrayOffsets[2]}, {y: 0}, '-=1')
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#publishcheck',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(animationBGpublishcheck)
      .reverse(true)
      //.addIndicators({ name: "#publishcheck" })
      .addTo(mainController))

    // -----------------  fintech8
    var animationBGfintech8 = new TimelineMax()
    animationBGfintech8
      .fromTo($(".fintech8Bg"), 1, {y: arrayOffsets[4]}, {y: -arrayOffsets[4]})
      .fromTo($(".fintech8Bg img"), 1, {rotation: 0}, {rotation: 360}, '-=1')
      .fromTo($("#fintech8 .bgTitleSection_l"), 1, {y: arrayOffsets[1] / 5}, {y: -arrayOffsets[1] / 5}, '-=1')
      .fromTo($("#fintech8 .startupsimg01"), 1, {y: arrayOffsets[2]}, {y: 0}, '-=1')
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#fintech8',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(animationBGfintech8)
      .reverse(true)
      //.addIndicators({ name: "#fintech8" })
      .addTo(mainController))

    // -----------------  lifted
    var animationBGlifted = new TimelineMax()
    animationBGlifted
      .fromTo($(".liftedBg"), 1, {y: arrayOffsets[4]}, {y: -arrayOffsets[4]})
      .fromTo($(".liftedBg img"), 1, {rotation: 0}, {rotation: 360}, '-=1')
      .fromTo($("#lifted .bgTitleSection_l"), 1, {y: arrayOffsets[1] / 5}, {y: -arrayOffsets[1] / 5}, '-=1')
      .fromTo($("#lifted .startupsimg01"), 1, {y: arrayOffsets[2]}, {y: 0}, '-=1')
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#lifted',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(animationBGlifted)
      .reverse(true)
      //.addIndicators({ name: "#lifted" })
      .addTo(mainController))

    // -----------------  intelify
    var animationBGintelify = new TimelineMax()
    animationBGintelify
      .fromTo($(".intelifyBg"), 1, {y: arrayOffsets[4]}, {y: -arrayOffsets[4]})
      .fromTo($(".intelifyBg img"), 1, {rotation: 0}, {rotation: 360}, '-=1')
      .fromTo($("#intelify .bgTitleSection_l"), 1, {y: arrayOffsets[1] / 5}, {y: -arrayOffsets[1] / 5}, '-=1')
      .fromTo($("#intelify .startupsimg01"), 1, {y: arrayOffsets[2]}, {y: 0}, '-=1')
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#intelify',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(animationBGintelify)
      .reverse(true)
      //.addIndicators({ name: "#intelify" })
      .addTo(mainController))


    // -----------------  superseed
    var animationBGsuperseed = new TimelineMax()
    animationBGsuperseed
      .fromTo($(".superseedBg"), 1, { y: arrayOffsets[4]}, {y: -arrayOffsets[4]})
      .fromTo($(".superseedBg img"), 1, {rotation: 0}, {rotation: 360}, '-=1')
      .fromTo($("#superseed .bgTitleSection_r"), 1, {y: arrayOffsets[1] / 5}, {y: -arrayOffsets[1] / 5}, '-=1')
      .fromTo($("#superseed .companiesimg01"), 1, {y: arrayOffsets[2]}, {y: 0}, '-=1')
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#superseed',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(animationBGsuperseed)
      .reverse(true)
      //.addIndicators({ name: "#superseed" })
      .addTo(mainController))


    // -----------------  supernice
    var animationBGsupernice = new TimelineMax()
    animationBGsupernice
      .fromTo($(".superniceBg"), 1, {y: arrayOffsets[4]}, {y: -arrayOffsets[4]})
      .fromTo($(".superniceBg img"), 1, {rotation: 0}, {rotation: 360}, '-=1')
      .fromTo($("#supernice .bgTitleSection_r"), 1, {y: arrayOffsets[1] / 5}, {y: -arrayOffsets[1] / 5}, '-=1')
      //.fromTo($("#supernice .companiesimg01"), 1, {y: arrayOffsets[2]}, {y: 0}, '-=1')
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#supernice',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(animationBGsupernice)
      .reverse(true)
      //.addIndicators({ name: "#supernice" })
      .addTo(mainController))

    // -----------------  advysr
    var animationBGadvysr = new TimelineMax()
    animationBGadvysr
      .fromTo($(".advysrBg"), 1, {y: arrayOffsets[4]}, {y: -arrayOffsets[4]})
      .fromTo($(".advysrBg img"), 1, {rotation: 0}, {rotation: 360}, '-=1')
      .fromTo($("#advysr .bgTitleSection_r"), 1, {y: arrayOffsets[1] / 5}, {y: -arrayOffsets[1] / 5}, '-=1')
      .fromTo($("#advysr .companiesimg01"), 1, {y: arrayOffsets[2]}, {y: 0}, '-=1')
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#advysr',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(animationBGadvysr)
      .reverse(true)
      //.addIndicators({ name: "#advysr" })
      .addTo(mainController))

    // -----------------  addintel
    var animationBGaddintel = new TimelineMax()
    animationBGaddintel
      .fromTo($(".addintelBg"), 1, {y: arrayOffsets[4]}, {y: -arrayOffsets[4]})
      .fromTo($(".addintelBg img"), 1, {rotation: 0}, {rotation: 360}, '-=1')
      .fromTo($("#addintel .bgTitleSection_r"), 1, {y: arrayOffsets[1] / 5}, {y: -arrayOffsets[1] / 5}, '-=1')
      .fromTo($("#addintel .companiesimg01"), 1, {y: arrayOffsets[2]}, {y: 0}, '-=1')
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#addintel',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(animationBGaddintel)
      .reverse(true)
      //.addIndicators({ name: "#addintel" })
      .addTo(mainController))

    // -----------------  homesearch
    var animationBGhomesearch = new TimelineMax()
    animationBGhomesearch
      .fromTo($(".homesearchBg"), 1, {y: arrayOffsets[4]}, {y: -arrayOffsets[4]})
      .fromTo($(".homesearchBg img"), 1, {rotation: 0}, {rotation: 360}, '-=1')
      .fromTo($("#homesearch .bgTitleSection_r"), 1, {y: arrayOffsets[1] / 5}, {y: -arrayOffsets[1] / 5}, '-=1')
      .fromTo($("#homesearch .companiesimg01"), 1, {y: arrayOffsets[2]}, {y: 0}, '-=1')
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#homesearch',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(animationBGhomesearch)
      .reverse(true)
      //.addIndicators({ name: "#homesearch" })
      .addTo(mainController))


    // -----------------  animationSlideBottom
    var animationSlideBottom = new TimelineMax()
    animationSlideBottom
      .fromTo($("#slideBottom .slideBottomLayer1"), 1, {y: arrayOffsets[1]}, {y: -arrayOffsets[1]}, "-=1")
      .fromTo($("#slideBottom h1"), 1, {y: arrayOffsets[3]}, {y: -arrayOffsets[3]}, "-=1")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: "#slideBottom",
        triggerHook: 0.5,
        duration: "100%"
      })
      .setTween(animationSlideBottom)
      //.addIndicators({ name: "animationSlideIntro" })
      .addTo(mainController)
    )

  } //preloaderAnimation.to($(".progress span"), 1, {width: 100,ease: Linear.easeNone}) && !Modernizr.touchevents

}
/*==========================================================================
        homeScrollMagic
==========================================================================*/




/*==========================================================================
        homeScrollMagicLaptop
==========================================================================*/

portfolioAPP.homeScrollMagicLaptop = function () {

    TweenMax.set([$("#baseup_1_, #basedown_1_")], { transformOrigin: "50% 0%" });
    TweenMax.set([$("#laptop_meetr, #laptop_publishcheck, #laptop_superseed, #laptop_supernice, #laptop_advysr, #laptop_addintel, #laptop_homesearch, #laptop_fintech8, #laptop_lifted, #laptop_intelify, #camera_x5F_screen, #screenShot, #trackpad")], { transformOrigin: "50% 50%" });
    TweenMax.set([$("#screenBackHalves, #halfScreenRight, #halfScreenLeft, #coverBG, #screenbgLeft_2_, #screenbgRight_2_")], { transformOrigin: "0% 100%" });

    // -----------------  meetr - screenAnimation
    var showAnimationMT = new TimelineMax()
    showAnimationMT
      //.to($("#laptop_meetr"), 0, { scale: 1.5 })
      .from($("#laptop_meetr #trackpad"), 1, { scaleX: 0 }, "-=0")
      .from($("#laptop_meetr #coverBG"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=1")
      .from($("#laptop_meetr #screenbgLeft_2_"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_meetr #screenbgRight_2_"), 2, { skewX: -35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_meetr #screenBackHalves"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_meetr #halfScreenRight"), 1.9, { skewX: -25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_meetr #halfScreenLeft"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_meetr #camera_x5F_screen #camera"), 1, { scale: 0, ease: Back.easeOut.config(0.5) }, "-=0")
      .from($("#laptop_meetr #screenShot"), 1, { alpha: 0, ease: Back.easeOut.config(0.5) }, "-=1.5")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#meetr',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(showAnimationMT)
      .addTo(mainController)
      .reverse(true)
    )

    // -----------------  publishcheck - screenAnimation
    var showAnimationPC = new TimelineMax()
    showAnimationPC
      //.to($("#laptop_publishcheck"), 0, { scale: 1.5 })
      .from($("#laptop_publishcheck #trackpad"), 1, { scaleX: 0 }, "-=0")
      .from($("#laptop_publishcheck #coverBG"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=1")
      .from($("#laptop_publishcheck #screenbgLeft_2_"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_publishcheck #screenbgRight_2_"), 2, { skewX: -35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_publishcheck #screenBackHalves"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_publishcheck #halfScreenRight"), 1.9, { skewX: -25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_publishcheck #halfScreenLeft"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_publishcheck #camera_x5F_screen #camera"), 1, { scale: 0, ease: Back.easeOut.config(0.5) }, "-=0")
      .from($("#laptop_publishcheck #screenShot"), 1, { alpha: 0, ease: Back.easeOut.config(0.5) }, "-=1.5")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#publishcheck',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(showAnimationPC)
      .addTo(mainController)
      .reverse(true)
    )

    // -----------------  superseed - screenAnimation
    var showAnimationSS = new TimelineMax()
    showAnimationSS
      //.to($("#laptop_superseed"), 0, { scale: 1.5 })
      .from($("#laptop_superseed #trackpad"), 1, { scaleX: 0 }, "-=0")
      .from($("#laptop_superseed #coverBG"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=1")
      .from($("#laptop_superseed #screenbgLeft_2_"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_superseed #screenbgRight_2_"), 2, { skewX: -35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_superseed #screenBackHalves"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_superseed #halfScreenRight"), 1.9, { skewX: -25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_superseed #halfScreenLeft"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_superseed #camera_x5F_screen #camera"), 1, { scale: 0, ease: Back.easeOut.config(0.5) }, "-=0")
      .from($("#laptop_superseed #screenShot"), 1, { alpha: 0, ease: Back.easeOut.config(0.5) }, "-=1.5")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#superseed',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(showAnimationSS)
      .addTo(mainController)
      .reverse(true)
    )

    // -----------------  supernice - screenAnimation
    var showAnimationSN = new TimelineMax()
    showAnimationSN
      //.to($("#laptop_supernice"), 0, { scale: 1.5 })
      .from($("#laptop_supernice #trackpad"), 1, { scaleX: 0 }, "-=0")
      .from($("#laptop_supernice #coverBG"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=1")
      .from($("#laptop_supernice #screenbgLeft_2_"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_supernice #screenbgRight_2_"), 2, { skewX: -35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_supernice #screenBackHalves"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_supernice #halfScreenRight"), 1.9, { skewX: -25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_supernice #halfScreenLeft"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_supernice #camera_x5F_screen #camera"), 1, { scale: 0, ease: Back.easeOut.config(0.5) }, "-=0")
      .from($("#laptop_supernice #screenShot"), 1, { alpha: 0, ease: Back.easeOut.config(0.5) }, "-=1.5")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#supernice',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(showAnimationSN)
      .addTo(mainController)
      .reverse(true)
    )

    // -----------------  fintech8 - screenAnimation
    var showAnimationF8 = new TimelineMax()
    showAnimationF8
      .from($("#laptop_fintech8 #trackpad"), 1, { scaleX: 0 }, "-=0")
      .from($("#laptop_fintech8 #coverBG"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=1")
      .from($("#laptop_fintech8 #screenbgLeft_2_"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_fintech8 #screenbgRight_2_"), 2, { skewX: -35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_fintech8 #screenBackHalves"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_fintech8 #halfScreenRight"), 1.9, { skewX: -25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_fintech8 #halfScreenLeft"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_fintech8 #camera_x5F_screen #camera"), 1, { scale: 0, ease: Back.easeOut.config(0.5) }, "-=0")
      .from($("#laptop_fintech8 #screenShot"), 1, { alpha: 0, ease: Back.easeOut.config(0.5) }, "-=1.5")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#fintech8',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(showAnimationF8)
      .addTo(mainController)
      .reverse(true)
    )

    // -----------------  lifted - screenAnimation
    var showAnimationLF = new TimelineMax()
    showAnimationLF
      .from($("#laptop_lifted #trackpad"), 1, { scaleX: 0 }, "-=0")
      .from($("#laptop_lifted #coverBG"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=1")
      .from($("#laptop_lifted #screenbgLeft_2_"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_lifted #screenbgRight_2_"), 2, { skewX: -35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_lifted #screenBackHalves"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_lifted #halfScreenRight"), 1.9, { skewX: -25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_lifted #halfScreenLeft"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_lifted #camera_x5F_screen #camera"), 1, { scale: 0, ease: Back.easeOut.config(0.5) }, "-=0")
      .from($("#laptop_lifted #screenShot"), 1, { alpha: 0, ease: Back.easeOut.config(0.5) }, "-=1.5")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#lifted',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(showAnimationLF)
      .addTo(mainController)
      .reverse(true)
    )

    // -----------------  intelify - screenAnimation
    var showAnimationIN = new TimelineMax()
    showAnimationIN
      .from($("#laptop_intelify #trackpad"), 1, { scaleX: 0 }, "-=0")
      .from($("#laptop_intelify #coverBG"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=1")
      .from($("#laptop_intelify #screenbgLeft_2_"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_intelify #screenbgRight_2_"), 2, { skewX: -35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_intelify #screenBackHalves"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_intelify #halfScreenRight"), 1.9, { skewX: -25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_intelify #halfScreenLeft"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_intelify #camera_x5F_screen #camera"), 1, { scale: 0, ease: Back.easeOut.config(0.5) }, "-=0")
      .from($("#laptop_intelify #screenShot"), 1, { alpha: 0, ease: Back.easeOut.config(0.5) }, "-=1.5")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#intelify',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(showAnimationIN)
      .addTo(mainController)
      .reverse(true)
    )

    // -----------------  advysr - screenAnimation
    var showAnimationAV = new TimelineMax()
    showAnimationAV
      .from($("#laptop_advysr #trackpad"), 1, { scaleX: 0 }, "-=0")
      .from($("#laptop_advysr #coverBG"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=1")
      .from($("#laptop_advysr #screenbgLeft_2_"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_advysr #screenbgRight_2_"), 2, { skewX: -35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_advysr #screenBackHalves"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_advysr #halfScreenRight"), 1.9, { skewX: -25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_advysr #halfScreenLeft"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_advysr #camera_x5F_screen #camera"), 1, { scale: 0, ease: Back.easeOut.config(0.5) }, "-=0")
      .from($("#laptop_advysr #screenShot"), 1, { alpha: 0, ease: Back.easeOut.config(0.5) }, "-=1.5")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#advysr',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(showAnimationAV)
      .addTo(mainController)
      .reverse(true)
    )

    // -----------------  addintel - screenAnimation
    var showAnimationAI = new TimelineMax()
    showAnimationAI
      .from($("#laptop_addintel #trackpad"), 1, { scaleX: 0 }, "-=0")
      .from($("#laptop_addintel #coverBG"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=1")
      .from($("#laptop_addintel #screenbgLeft_2_"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_addintel #screenbgRight_2_"), 2, { skewX: -35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_addintel #screenBackHalves"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_addintel #halfScreenRight"), 1.9, { skewX: -25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_addintel #halfScreenLeft"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_addintel #camera_x5F_screen #camera"), 1, { scale: 0, ease: Back.easeOut.config(0.5) }, "-=0")
      .from($("#laptop_addintel #screenShot"), 1, { alpha: 0, ease: Back.easeOut.config(0.5) }, "-=1.5")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#addintel',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(showAnimationAI)
      .addTo(mainController)
      .reverse(true)
    )

    // -----------------  homesearch - screenAnimation
    var showAnimationHS = new TimelineMax()
    showAnimationHS
      .from($("#laptop_homesearch #trackpad"), 1, { scaleX: 0 }, "-=0")
      .from($("#laptop_homesearch #coverBG"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=1")
      .from($("#laptop_homesearch #screenbgLeft_2_"), 2, { skewX: 35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_homesearch #screenbgRight_2_"), 2, { skewX: -35, scaleY: 0, ease: Power3.easeOut }, "-=2")
      .from($("#laptop_homesearch #screenBackHalves"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_homesearch #halfScreenRight"), 1.9, { skewX: -25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_homesearch #halfScreenLeft"), 1.9, { skewX: 25, scaleY: 0, ease: Power3.easeOut }, "-=1.9")
      .from($("#laptop_homesearch #camera_x5F_screen #camera"), 1, { scale: 0, ease: Back.easeOut.config(0.5) }, "-=0")
      .from($("#laptop_homesearch #screenShot"), 1, { alpha: 0, ease: Back.easeOut.config(0.5) }, "-=1.5")
    scenes.push(
      new ScrollMagic.Scene({
        triggerElement: '#homesearch',
        triggerHook: .5,
        duration: "100%"
      })
      .setTween(showAnimationHS)
      .addTo(mainController)
      .reverse(true)
    )
}
/*==========================================================================
        homeScrollMagicLaptop
==========================================================================*/






/*==========================================================================
        homeGrid
==========================================================================*/
portfolioAPP.homeGrid = function () {

  var support = {
      transitions: Modernizr.csstransitions
    },
    // transition end event name
    transEndEventNames = {
      'WebkitTransition': 'webkitTransitionEnd',
      'MozTransition': 'transitionend',
      'OTransition': 'oTransitionEnd',
      'msTransition': 'MSTransitionEnd',
      'transition': 'transitionend'
    },
    transEndEventName = transEndEventNames[Modernizr.prefixed('transition')],
    onEndTransition = function (el, callback) {
      var onEndCallbackFn = function (ev) {
        if (support.transitions) {
          if (ev.target != this) return;
          this.removeEventListener(transEndEventName, onEndCallbackFn);
        }
        if (callback && typeof callback === 'function') {
          callback.call(this);
        }
      };
      if (support.transitions) {
        el.addEventListener(transEndEventName, onEndCallbackFn);
      } else {
        onEndCallbackFn();
      }
    };

  new GridFx(document.querySelector('.gridHome'), {
    imgPosition: {
      x: -0.5,
      y: 1
    },
    onOpenItem: function (instance, item) {
      if (portfolioAPP.onInitialise()!='isTouchDevice'){
        $('.preview, .action').css({
          top: scrollBar.scrollTop + 'px'
        })
      }
      $('.nav').hide()
      document.querySelector(".preview").addEventListener('wheel', e => e.preventDefault());
      document.querySelector(".preview").addEventListener('touchmove', function(e) {e.preventDefault();}, true);

      instance.items.forEach(function (el) {
        if (item != el) {
          var delay = Math.floor(Math.random() * 50);
          el.style.WebkitTransition = 'opacity .5s ' + delay + 'ms cubic-bezier(.7,0,.3,1), -webkit-transform .5s ' + delay + 'ms cubic-bezier(.7,0,.3,1)';
          el.style.transition = 'opacity .5s ' + delay + 'ms cubic-bezier(.7,0,.3,1), transform .5s ' + delay + 'ms cubic-bezier(.7,0,.3,1)';
          el.style.WebkitTransform = 'scale3d(0.1,0.1,1)';
          el.style.transform = 'scale3d(0.1,0.1,1)';
          el.style.opacity = 0;
        }
      });
    },
    onCloseItem: function (instance, item) {
      $('.nav').show()
      instance.items.forEach(function (el) {
        if (item != el) {
          el.style.WebkitTransition = 'opacity .4s, -webkit-transform .4s';
          el.style.transition = 'opacity .4s, transform .4s';
          el.style.WebkitTransform = 'scale3d(1,1,1)';
          el.style.transform = 'scale3d(1,1,1)';
          el.style.opacity = 1;

          onEndTransition(el, function () {
            el.style.transition = 'none';
            el.style.WebkitTransform = 'none';
          });
        }
      });
    }
  });
}
/*==========================================================================
        homeGrid
==========================================================================*/